import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import BaseGraphics from '../views/BaseGraphics.vue'


import Brand from '../views/Brand'

Vue.use(VueRouter)

const routes = [
    {
        path: '/', name: 'Home', component: Home
    },
    {
        path: '/brand', name: 'Brand', component: Brand
    },
    {
        path: '/base-graphics', name: 'BaseGraphics', component: BaseGraphics
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash && from.hash) {
            return document.querySelector(to.hash).scrollIntoView({behavior: 'smooth'});
        } else {
            //console.log('savedPos:');
            //console.log(savedPosition);
            //console.log(to.hash);

            if (savedPosition) {
                return savedPosition
            }
            return to.hash ? document.querySelector(to.hash).scrollIntoView({}) : {x: 0, y: 0};
        }
    },
    routes
})

export default router
